import { useLayoutEffect, useRef } from "react";

// A ref that holds the latest committed value, for event handlers and effects that must not re-subscribe when it
// changes. It is written after the render commits (a layout effect runs before any passive effect or event), not
// during render, so a render React throws away never leaks into it. Code that changes the value imperatively
// (a drag writing the box before the state lands) can still write `ref.current` itself.
export function useLatestRef(value) {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
